import { queryAll } from './dom.js';

export function initGiftCardMessage() {
  queryAll('[data-gift-card-message]').forEach(widget => {
    const inset       = widget.querySelector('.gift-card-message__inset');
    const field       = widget.querySelector('.gift-card-message__field');
    const placeholder = widget.querySelector('.gift-card-message__placeholder');

    if (!field || !inset) return;

    let lastValid = '';

    // Grow the textarea to its content height (scrollHeight with height=0
    // gives the true content height regardless of overflow setting).
    // If content would exceed the inset, revert to the last valid value.
    function resize() {
      field.style.height = '0';
      const contentH = field.scrollHeight;
      const maxH     = inset.clientHeight;

      if (contentH > maxH) {
        field.value        = lastValid;
        field.style.height = '0';
        field.style.height = field.scrollHeight + 'px';
      } else {
        lastValid          = field.value;
        field.style.height = contentH + 'px';
      }
    }

    // Show placeholder only when the field is empty and not focused.
    function syncPlaceholder() {
      if (!placeholder) return;
      const show = field.value === '' && document.activeElement !== field;
      if (show) {
        placeholder.removeAttribute('hidden');
      } else {
        placeholder.setAttribute('hidden', '');
      }
    }

    widget.querySelector('.gift-card-message__card').addEventListener('click', () => {
      field.focus();
    });

    field.addEventListener('focus', syncPlaceholder);
    field.addEventListener('blur',  syncPlaceholder);
    field.addEventListener('input', () => {
      resize();
      syncPlaceholder();
    });

    resize();
    syncPlaceholder();
  });
}
